export default __webpack_public_path__ + "static/logo-fb281ef158c9d624a8e31ad9b91a3055.png";